module.exports = __webpack_public_path__ + "static/media/peso_blanco.6fba93f3.svg";